<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      persistent
      scrollable
      max-width="800px"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          Disapproved Leave Application <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text
          style="max-height: 780px; max-width:1300px; margin: 0 auto; "
          class="mt-4"
        >
          <v-card class="my-5 dt-container" elevation="1">
            <v-data-table
              :headers="headers"
              :items="disapprovedData"
              :options.sync="options"
              :loading="loading"
            >
              <template v-slot:[`item.createdAt`]="{ item }">
                {{
                  item.date_filed
                    ? formatDate(item.date_filed)
                    : formatDate(item.createdAt)
                }}
              </template>
              <template v-slot:[`item.types.description`]="{ item }">
                {{
                  item.type_of_leave_ID == 14
                    ? item.selected_details_of_leave == 1
                      ? item.types.description + "/Monetization"
                      : item.selected_details_of_leave == 2
                      ? item.types.description + "/Terminal Leave"
                      : item.selected_details_of_leave == 3
                      ? item.types.description + "/CTO"
                      : ""
                    : item.types.description
                }}
              </template>
              <template v-slot:[`item.hr_status`]="{ item }">
                <v-chip
                  v-if="
                    (item.certifying_hr_status == 1 ||
                      item.certifying_hr_status == null ||
                      item.certifying_hr_status == 2) &&
                      (item.hr_status == 1 || item.hr_status == null)
                  "
                  class="ma-2"
                  x-small
                >
                  For Approval
                </v-chip>

                <v-icon
                  color="#519043"
                  v-if="item.hr_status == 2 && item.certifying_hr_status == 2"
                  >mdi-check</v-icon
                >
                <v-icon
                  color="red"
                  v-if="item.hr_status == 3 || item.certifying_hr_status == 3"
                  >mdi-comment-alert</v-icon
                >
              </template>

              <template v-slot:[`item.recommending_status`]="{ item }">
                <div
                  v-if="
                    item.recommending_user_detailID != null &&
                      item.recommending_user_detailID !=
                        item.final_approval_user_detailID
                  "
                >
                  <div
                    v-if="
                      item.type_of_leave_ID == 14 &&
                        item.selected_details_of_leave == 1
                    "
                  >
                    -
                  </div>
                  <div v-else>
                    <v-chip
                      v-if="item.recommending_status == null"
                      class="ma-2"
                      x-small
                    >
                      For Approval
                    </v-chip>
                    <v-icon color="#519043" v-if="item.recommending_status == 1"
                      >mdi-check</v-icon
                    >

                    <v-icon color="error" v-if="item.recommending_status == 2"
                      >mdi-comment-alert</v-icon
                    >
                  </div>
                </div>
                <div
                  v-if="
                    item.recommending_user_detailID != null &&
                      item.recommending_user_detailID ==
                        item.final_approval_user_detailID
                  "
                >
                  <div
                    v-if="
                      item.type_of_leave_ID == 14 &&
                        item.selected_details_of_leave == 1
                    "
                  >
                    -
                  </div>
                  <div v-else>
                    <v-chip
                      v-if="item.recommending_status == null"
                      class="ma-2"
                      x-small
                    >
                      For Approval
                    </v-chip>
                    <v-icon color="#519043" v-if="item.recommending_status == 1"
                      >mdi-check</v-icon
                    >

                    <v-icon color="error" v-if="item.recommending_status == 2"
                      >mdi-comment-alert</v-icon
                    >
                  </div>
                </div>
                <div v-if="item.recommending_user_detailID == null">
                  -
                </div>
              </template>

              <template
                v-slot:[`item.is_final_approval_disapproved`]="{ item }"
              >
                <v-chip
                  v-if="
                    item.is_final_approval_disapproved == null &&
                      item.is_final_approval_pending == 0
                  "
                  class="ma-2"
                  x-small
                >
                  For Approval
                </v-chip>
                <v-icon
                  color="#519043"
                  v-if="item.is_final_approval_disapproved == 0"
                  >mdi-check</v-icon
                >

                <v-icon
                  color="error"
                  v-if="
                    item.is_final_approval_disapproved == 1 ||
                      item.is_final_approval_pending == 1
                  "
                  >mdi-comment-alert</v-icon
                >
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  elevation="2"
                  color="#17C800"
                  class="white--text mx-1"
                  x-small
                  @click="viewItem('View', item)"
                >
                  <v-icon size="14">mdi-eye</v-icon>
                  view</v-btn
                >

                <v-chip
                  small
                  v-if="item.leaveCredit && item.leaveCredit.isRestored == 1"
                  class="ma-2"
                  color="warning"
                  text-color="white"
                  >LEAVE CREDIT RESTORED</v-chip
                >
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            outlined
            @click="
              close();
              dialog = false;
            "
          >
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>
          <!-- <v-btn
            :color="$vuetify.theme.themes.light.submitBtns"
            class="white--text"
            @click="submitCTO()"
          >
            <v-icon>mdi-check-circle</v-icon>
            SUBMIT
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ViewLeaveDataDialog :data="viewData" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
  },
  components: {
    ViewLeaveDataDialog: () => import("../Views/ViewLeaveDataDialog"),
    //   import("../Forms/MyLeaveDialog.vue"),
  },
  data() {
    return {
      dialog: false,
      options: {},
      search: "",
      action: null,
      disapprovedData: [],
      viewData: null,
      headers: [
        {
          text: "Date Filed",
          value: "createdAt",
          align: "start",
          valign: "center",
        },
        {
          text: "Leave Type",
          value: "types.description",
          align: "center",
          valign: "center",
        },

        {
          text: "Leave Credit Certification",
          value: "hr_status",
          align: "center",
          valign: "center",
        },

        {
          text: "Recommendation",
          value: "recommending_status",
          align: "center",
          valign: "center",
        },

        {
          text: "Approval",
          value: "is_final_approval_disapproved",
          align: "center",
          valign: "center",
        },

        {
          text: "Actions",
          value: "actions",
          align: "center",
          valign: "center",
          sortable: false,
        },
      ],
      loading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  mounted() {
    this.eventHub.$on("closeViewLeaveDataDialog", () => {
      this.initialize();
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewLeaveDataDialog");
  },

  watch: {
    data: {
      handler(data) {
        // if (data) {
        console.log("Disapprove Data", data);
        this.dialog = true;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {},
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.loading = true;
      let filter = this.$store.getters.getFilterSelected;
      this.axiosCall(
        "/leaves/getDisapprovedLeaveApplication/" +
          filter +
          "/" +
          this.data.empID,
        "GET"
      ).then((res) => {
        if (res) {
          this.disapprovedData = res.data;
          console.log(res.data);
          this.loading = false;
        }
      });
    },
    viewItem(action, item) {
      this.viewData = item;
      this.action = action;
    },

    close() {
      this.eventHub.$emit("closeDisapprovedApplicationDialog", false);
      this.dialog = false;
    },
  },
};
</script>
<style scoped></style>
